import { Injectable } from '@angular/core';

import { MultiProductTemplateModel } from '../models/multi-product-types-model';
import { TypeOfTemplate } from '../models/templates-types.models';

import { Resolutions } from '@layout/domain/models/layout.models';
import { Position } from '@shared/product/models';

@Injectable()
export class MultiProductTemplateConfigurations {
    public getConfig(): Record<string, MultiProductTemplateModel> {
        return {
            CC: {
                type: TypeOfTemplate.MultiProductTemplate,
                ulClasses: '',
                liClasses: 'grid-product-list',
                name: '1CC',
                cmsStyles: undefined,
                templateConfiguration: {
                    imageType: undefined,
                    showDescription: false,
                    showTags: true,
                    showPrice: true,
                    showQuickly: true,
                    showQuicklyMobile: true,
                    textPosition: Position.bottom,
                    showColors: true,
                    showDiscount: true,
                    showMadeInExclusive: true,
                    media: {
                        widthVW: '50vw',
                        ratio: '3-4',
                    },
                },
                imageWidth: {
                    useMobileConfig: Resolutions.MOBILE,
                    mobile: null,
                    desktop: null,
                },
                showName: {
                    useMobileConfig: Resolutions.MOBILE,
                    mobile: 1,
                    desktop: 1,
                },
                skLoad: {
                    useMobileConfig: Resolutions.MOBILE,
                    mobile: 2,
                    desktop: 2,
                },
            },
            '3A': {
                type: TypeOfTemplate.MultiProductTemplate,
                ulClasses: '',
                liClasses: 'grid-product-list',
                name: '3A',
                cmsStyles: undefined,
                templateConfiguration: {
                    imageType: undefined,
                    showDescription: false,
                    showTags: true,
                    showPrice: true,
                    showQuickly: true,
                    showQuicklyMobile: true,
                    textPosition: Position.bottom,
                    showColors: true,
                    showDiscount: true,
                    showMadeInExclusive: true,
                    media: {
                        widthVW: '(max-width: 767px) 50vw, 25vw',
                        ratio: '3-4',
                    },
                },
                imageWidth: {
                    useMobileConfig: Resolutions.MOBILE,
                    mobile: null,
                    desktop: null,
                },
                showName: {
                    useMobileConfig: Resolutions.MOBILE,
                    mobile: 1,
                    desktop: 1,
                },
                skLoad: {
                    useMobileConfig: Resolutions.MOBILE,
                    mobile: 2,
                    desktop: 2,
                },
            },
            '4A': {
                type: TypeOfTemplate.MultiProductTemplate,
                ulClasses: '',
                liClasses: 'grid-product-list',
                name: '4A',
                cmsStyles: undefined,
                templateConfiguration: {
                    imageType: undefined,
                    showDescription: false,
                    showTags: true,
                    showPrice: true,
                    showQuickly: true,
                    showQuicklyMobile: true,
                    textPosition: Position.bottom,
                    showColors: true,
                    showDiscount: true,
                    showMadeInExclusive: true,
                    media: {
                        widthVW: '(max-width: 767px) 50vw, 25vw',
                        ratio: '3-4',
                    },
                },
                imageWidth: {
                    useMobileConfig: Resolutions.MOBILE,
                    mobile: null,
                    desktop: null,
                },
                showName: {
                    useMobileConfig: Resolutions.MOBILE,
                    mobile: 1,
                    desktop: 1,
                },
                skLoad: {
                    useMobileConfig: Resolutions.MOBILE,
                    mobile: 2,
                    desktop: 2,
                },
            },
            '1LE': {
                type: TypeOfTemplate.MultiProductTemplate,
                ulClasses: '',
                liClasses: 'grid-product-list',
                name: '1LE',
                cmsStyles: undefined,
                templateConfiguration: {
                    imageType: undefined,
                    showDescription: false,
                    showTags: false,
                    showPrice: false,
                    showQuickly: false,
                    showDetails: false,
                    textPosition: Position.none,
                    showColors: false,
                    showDiscount: false,
                    showMadeInExclusive: false,
                    media: {
                        widthVW: '40vw',
                        ratio: '3-4',
                    },
                },
                imageWidth: {
                    useMobileConfig: Resolutions.MOBILE,
                    mobile: null,
                    desktop: null,
                },
                showName: {
                    useMobileConfig: Resolutions.MOBILE,
                    mobile: 0,
                    desktop: 0,
                },
                skLoad: {
                    useMobileConfig: Resolutions.MOBILE,
                    mobile: 6,
                    desktop: 6,
                },
            },
            '4B': {
                type: TypeOfTemplate.MultiProductTemplate,
                ulClasses: '',
                liClasses: 'grid-product-list',
                name: '4B',
                cmsStyles: undefined,
                templateConfiguration: {
                    imageType: undefined,
                    showDescription: false,
                    showTags: true,
                    showPrice: true,
                    showQuickly: true,
                    showQuicklyMobile: true,
                    textPosition: Position.bottom,
                    showColors: true,
                    showDiscount: true,
                    showMadeInExclusive: true,
                    media: {
                        widthVW: '(max-width: 767px) 25vw, 25vw',
                        ratio: '3-4',
                    },
                },
                imageWidth: {
                    useMobileConfig: Resolutions.MOBILE,
                    mobile: null,
                    desktop: null,
                },
                showName: {
                    useMobileConfig: Resolutions.MOBILE,
                    mobile: 1,
                    desktop: 1,
                },
                skLoad: {
                    useMobileConfig: Resolutions.MOBILE,
                    mobile: 2,
                    desktop: 2,
                },
            },
            '2FV': {
                type: TypeOfTemplate.MultiProductTemplate,
                ulClasses: 'grid-product__section',
                liClasses: 'grid-product-list',
                name: '2FV',
                cmsStyles: '',
                templateConfiguration: {
                    imageType: undefined,
                    showDescription: false,
                    showTags: true,
                    showPrice: true,
                    showQuickly: false,
                    textPosition: Position.bottom,
                    showColors: true,
                    showDiscount: true,
                    showMadeInExclusive: true,
                    media: {
                        widthVW: '(max-width: 767px) 100vw, 50vw',
                        ratio: '3-4',
                    },
                },
                imageWidth: {
                    useMobileConfig: Resolutions.MOBILE,
                    mobile: null,
                    desktop: null,
                },
                showName: {
                    useMobileConfig: Resolutions.MOBILE,
                    mobile: 1,
                    desktop: 1,
                },
                skLoad: {
                    useMobileConfig: Resolutions.MOBILE,
                    mobile: 2,
                    desktop: 2,
                },
            },
        };
    }
}
